module.exports = new __parcel__URL__("rogue.28e06f56.png").toString();